export const commonNn = {
    errors: {
        somethingWentWrong: 'Noko gjekk gale!',
        defaultMessage: 'Orsak, det oppstod ein teknisk feil. Ver vennleg og prøv igjen om ei tid.',
        errorCode: 'Feilkode',
        copyErrorCode: 'Kopier feilkode',
        retryButton: 'Prøv igjen',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvc2hhcmVkL3RyYW5zbGF0aW9ucy9jb21tb24vbm4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sUUFBUSxHQUFxQjtJQUN0QyxNQUFNLEVBQUU7UUFDSixrQkFBa0IsRUFBRSxrQkFBa0I7UUFDdEMsY0FBYyxFQUFFLDJFQUEyRTtRQUMzRixTQUFTLEVBQUUsVUFBVTtRQUNyQixhQUFhLEVBQUUsaUJBQWlCO1FBQ2hDLFdBQVcsRUFBRSxZQUFZO0tBQzVCO0NBQ0osQ0FBQyJ9